// extracted by mini-css-extract-plugin
module.exports = {"default_landing_page_container":"DefaultLandingPage_default_landing_page_container__DXTpP"};